import * as React from 'react';

import styles from './Routes.scss';
import { RoutesLocale } from './routes.locale';
import CardWithIcon from '../../Card/CardWithIcon';
import List from '../../List/List';

import treasurePathIcon from '../../Icon/treasurePath.svg';
import maintenanceIcon from '../../Icon/maintenance.svg';
import cloudIcon from '../../Icon/cloud.svg';

interface RoutesProps {
  locale: RoutesLocale;
}

const icons = [treasurePathIcon, maintenanceIcon, cloudIcon];

const Routes: React.SFC<RoutesProps> = ({ locale }) => (
  <>
    <div className="d-flex justify-content-center mb-6">
      <div className="col-12 col-md-8 text-center">
        <h2 className="mb-0">{locale.title}</h2>
      </div>
    </div>

    <div className="container">
      <div className="row">
        <div className="col-12 col-md-6">
          <div className={styles.boxes}>
            {locale.boxes.map((item, index) => (
              <div key={index} className="mb-3">
                <CardWithIcon icon={icons[index]}>
                  <span dangerouslySetInnerHTML={{ __html: item }} />
                </CardWithIcon>
              </div>
            ))}
          </div>
        </div>
        <div className="col-12 col-md-6">
          <List
            items={locale.list.map((item, index) => (
              <span key={index} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          />
        </div>
      </div>
    </div>
  </>
);

export default Routes;



// WEBPACK FOOTER //
// /www/client/src/components/TechnicalPage/Routes/Routes.tsx